import Clickable from "@components/clickable";
import { ConfirmationDialog } from "@components/dialog/ConfirmationDialog";
import { DownloadIcon } from "@components/icon";
import { DateInput } from "@components/inputs/date";
import Field from "@components/inputs/field";
import FieldsWrapper from "@components/inputs/field/FieldsWrapper";
import { ExportTextWrapper } from "@pages/payroll/submission/Submission.styles";
import { exportToXML } from "@pages/payroll/submission/Submission.utils";
import React from "react";
import { Trans } from "react-i18next";

import { BasicInputSizes, IconSize, TextAlign } from "../../../enums";
import { Model } from "../../../model/Model";
import DateType, { DateFormat, getLocalTimeDate } from "../../../types/Date";

interface IProps {
    storage: Model;
    ids: number[];
    onClose: () => void;
    onConfirm: (dateSubmitted: Date) => void;
}

interface IState {
    dateSubmitted: Date;
    isBusy: boolean;
}

class ExportSubmissionDialog extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            dateSubmitted: getLocalTimeDate(),
            isBusy: false
        };
    }

    get isMassExport(): boolean {
        return this.props.ids.length > 1;
    }

    handleExport = async (e: React.SyntheticEvent): Promise<void> => {
        e.preventDefault();
        this.setState({ isBusy: true });

        try {
            // export to XML file, download the content directly
            await exportToXML(this.props.storage, this.props.ids);
        } finally {
            this.setState({ isBusy: false });
        }
    };

    handleClose = (): void => {
        this.props.onClose();
    };

    handleConfirm = (): void => {
        this.props.onConfirm(this.state.dateSubmitted);
    };

    formatInputValue = (value: Date): string => {
        return value ? DateType.format(value, DateFormat.dateAndTime, { local: true }) : "";
    }

    render() {
        const { storage } = this.props;
        const title = storage.t(this.isMassExport ? "Submission:ExportXmlDialogTitleMultiple"
            : "Submission:ExportXMLDialogTitle");
        const messageKey = this.isMassExport ? "Submission:ExportXmlDialogMessageMultiple"
            : "Submission:ExportXmlDialogMessage";
        return (
            <ConfirmationDialog title={title}
                                onClose={this.handleClose}
                                onConfirm={this.handleConfirm}>
                <FieldsWrapper>
                    <Field label={storage.t("Submission:DateSubmission")}
                           isReadOnly
                           width={BasicInputSizes.M}
                           textAlign={TextAlign.Left}>
                        <DateInput value={this.state.dateSubmitted}
                                   isReadOnly
                                   formatter={this.formatInputValue}
                                   textAlign={TextAlign.Left}
                                   width={BasicInputSizes.M}/>
                    </Field>
                </FieldsWrapper>
                <ExportTextWrapper>
                    <Trans i18nKey={messageKey}
                           components={{
                               drilldown: <Clickable onClick={this.handleExport}
                                                     isDisabled={this.state.isBusy} />,
                               downloadIcon: <DownloadIcon width={IconSize.XS}
                                                           height={IconSize.XS}
                                                           isBusy={this.state.isBusy} />
                           }}
                    />
                </ExportTextWrapper>
            </ConfirmationDialog>
        );
    }
}

export default ExportSubmissionDialog;